"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullProductNameHeader = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _ProductNameHeader = require("../../molecules/ProductNameHeader");

var _FeaturesBar = require("../../molecules/FeaturesBar");

var _AvatarAndValidation = require("../../molecules/AvatarAndValidation");

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

var FullProductNameHeader = function FullProductNameHeader(_ref) {
  var _headerData$article, _headerData$article2, _headerData$article3, _headerData$article4, _headerData$article5;

  var headerData = _ref.headerData,
      percent = _ref.percent,
      activeRetailer = _ref.activeRetailer,
      setActiveRetailer = _ref.setActiveRetailer,
      showValidationButtons = _ref.showValidationButtons,
      approve = _ref.approve,
      reject = _ref.reject,
      approveAll = _ref.approveAll,
      rejectAll = _ref.rejectAll,
      servicesData = _ref.servicesData,
      showApproveRejectAll = _ref.showApproveRejectAll,
      productObservation = _ref.productObservation,
      isObservationVisible = _ref.isObservationVisible,
      toggleObservation = _ref.toggleObservation,
      hideObservation = _ref.hideObservation;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      retailers = _useState2[0],
      setRetailers = _useState2[1];

  (0, _react.useEffect)(function () {
    var rtls = (headerData === null || headerData === void 0 ? void 0 : headerData.retailers) || (headerData === null || headerData === void 0 ? void 0 : headerData.retailersAvailable);
    servicesData && (rtls === null || rtls === void 0 ? void 0 : rtls.forEach(function (rt) {
      var element = [];
      servicesData.forEach(function (sd) {
        if (sd.id_retailer === rt.id) {
          element.push(sd.status ? sd.status : "R");
        } else element.push("NA");

        rt["services"] = element;
      });
    }));
    setRetailers(rtls);
  }, [servicesData]);

  var getTime = function getTime(date) {
    if (!date) return "";
    return new Date(date).toLocaleDateString();
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductNameHeader.ProductNameHeader, {
      productName: (headerData === null || headerData === void 0 ? void 0 : (_headerData$article = headerData.article) === null || _headerData$article === void 0 ? void 0 : _headerData$article.name) || (headerData === null || headerData === void 0 ? void 0 : headerData.name),
      statusType: (headerData === null || headerData === void 0 ? void 0 : headerData.version_status) || (headerData === null || headerData === void 0 ? void 0 : headerData.status) || (headerData === null || headerData === void 0 ? void 0 : headerData.article_status),
      percentRequired: percent,
      percent: percent === null || percent === void 0 ? void 0 : percent.toFixed(0),
      priority: headerData === null || headerData === void 0 ? void 0 : headerData.prio,
      productObservation: productObservation,
      date: getTime((headerData === null || headerData === void 0 ? void 0 : (_headerData$article2 = headerData.article) === null || _headerData$article2 === void 0 ? void 0 : _headerData$article2.timestamp) || (headerData === null || headerData === void 0 ? void 0 : headerData.timestamp)),
      dataProduct: headerData,
      isObservationVisible: isObservationVisible,
      toggleObservation: toggleObservation // handleClickOutside ={handleClickOutside}
      ,
      hideObservation: hideObservation
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "features-bar-container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FeaturesBar.FeaturesBar, {
        features: [{
          feature: "Categoría",
          value: (headerData === null || headerData === void 0 ? void 0 : (_headerData$article3 = headerData.article) === null || _headerData$article3 === void 0 ? void 0 : _headerData$article3.category) || (headerData === null || headerData === void 0 ? void 0 : headerData.categoryName)
        }, {
          feature: "Prov",
          value: headerData === null || headerData === void 0 ? void 0 : (_headerData$article4 = headerData.article) === null || _headerData$article4 === void 0 ? void 0 : _headerData$article4.company_name
        }, {
          feature: "SKU",
          value: (headerData === null || headerData === void 0 ? void 0 : (_headerData$article5 = headerData.article) === null || _headerData$article5 === void 0 ? void 0 : _headerData$article5.upc) || (headerData === null || headerData === void 0 ? void 0 : headerData.upc)
        }]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AvatarAndValidation.AvatarAndValidation, {
        retailers: retailers,
        avatarData: headerData === null || headerData === void 0 ? void 0 : headerData.avatarData,
        validation: headerData === null || headerData === void 0 ? void 0 : headerData.validation,
        activeRetailer: activeRetailer,
        setActiveRetailer: setActiveRetailer,
        showValidationButtons: showValidationButtons,
        showApproveRejectAll: showApproveRejectAll,
        approve: approve,
        reject: reject,
        approveAll: approveAll,
        rejectAll: rejectAll
      })]
    })]
  });
};

exports.FullProductNameHeader = FullProductNameHeader;